// @flow
import {TypedUseSelectorHook, useSelector} from 'react-redux';
import {createStore, applyMiddleware, compose} from 'redux';
import {defaultInitialState, rootEpic, rootReducer} from '../modules';
import {createEpicMiddleware} from 'redux-observable';
import * as Sentry from '@sentry/react';

import type {RootState} from '../modules';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

const configureStore = (initialState: RootState = defaultInitialState) => {
  const middlewares = [];
  // Redux observable
  const epic = createEpicMiddleware();
  middlewares.push(epic);
  const appliedMiddlewares = applyMiddleware(...middlewares);
  let store;

  const sentryReduxEnhancer = Sentry.createReduxEnhancer({});
  const composeEnhancers =
    window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;
  const enhancer = composeEnhancers(appliedMiddlewares, sentryReduxEnhancer);

  if (process.env.NODE_ENV === 'development' && window) {
    store = createStore<*, *, *, *>(rootReducer, initialState, enhancer);
  } else {
    store = createStore<*, *, *, *>(rootReducer, initialState, enhancer);
  }
  epic.run(rootEpic);
  return store;
};

let store;
export function getStore() {
  if (!store) {
    store = configureStore();
  }
  return store;
}

export default configureStore;
